export function controllerMidiEvent(deltaTime, channel, controllerType, value) {
    return {
        deltaTime,
        type: "channel",
        subtype: "controller",
        channel,
        controllerType,
        value,
    };
}
export function gsResetMidiEvent(deltaTime, data) {
    return {
        deltaTime,
        type: "sysEx",
        data
    };
}
//# sourceMappingURL=MidiEventFactory.js.map